<template>
  <div class="flex flex-row text-sm py-2">
    <form @submit.prevent="submitAction">
      <select class="border border-gray-400 p-1 rounded mr-2" v-model="form.action">
        <option :value="null">---</option>
        <option v-if="user.pivot.approved == 0" value="approve">Approve</option>
        <option value="unlink">Unlink</option>
      </select>
      <button type="submit" class="bg-gray-200 border-gray-100 border hover:bg-gray-100 hover:border-gray-200 text-xs px-2 py-1 rounded">Update</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'UserActionForm',
  props: {
    customerId: Number,
    user: Object
  },

  data() {
    return {
      form: {
        action: null
      }
    }
  },

  methods: {
    submitAction() {
      this.$inertia.post(this.route('customer-account-user-action', {customer: this.customerId, user: this.user.id}), this.form);
    }
  }
}
</script>
